module.exports = __webpack_public_path__ + "img/icon_map_0_off_110.c11f4fb2.png";